module.exports = __webpack_public_path__ + "img/borchia_7.c451b981.svg";